import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function AdminContactMessages() {
    const [items, setItems] = useState([]);
    const [unread, setUnread] = useState(0);
    const [active, setActive] = useState(null);

    const refresh = async () => {
        const { data } = await api.get("/admin/contact-messages");
        setItems(data.items || []);
        setUnread(data.unread || 0);
    };
    useEffect(() => { refresh(); }, []);

    const markRead = async (m, read) => {
        try {
            await api.patch(`/admin/contact-messages/${m.id}`, { read });
            refresh();
            if (active && active.id === m.id) setActive({ ...active, read });
        } catch (_e) { toast.error("Could not update"); }
    };

    return (
        <div data-testid="admin-contact-messages-page">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
                <div>
                    <span className="label-eyebrow">Inbox</span>
                    <h1 className="mt-2 font-display text-4xl text-inkDark">Contact messages</h1>
                    <p className="mt-1 text-inkMuted">{items.length} total · {unread} unread.</p>
                </div>
                <div className="text-xs text-inkMuted bg-beige rounded-full px-3 py-1.5">Email delivery: <strong>MOCKED</strong> &mdash; messages stored only.</div>
            </div>

            <div className="mt-8 bg-ivory rounded-2xl border border-inkDark/5 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm" data-testid="admin-contact-table">
                        <thead className="bg-beige text-inkMuted">
                            <tr>
                                <th className="text-left px-4 py-3 font-medium">From</th>
                                <th className="text-left px-4 py-3 font-medium">Subject</th>
                                <th className="text-left px-4 py-3 font-medium">Received</th>
                                <th className="text-left px-4 py-3 font-medium">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((m) => (
                                <tr
                                    key={m.id}
                                    onClick={() => { setActive(m); if (!m.read) markRead(m, true); }}
                                    className={`border-t border-inkDark/5 cursor-pointer hover:bg-beige/40 ${!m.read ? "font-medium" : ""}`}
                                    data-testid={`admin-contact-row-${m.id}`}
                                >
                                    <td className="px-4 py-3 text-inkDark">{m.name}<div className="text-xs text-inkMuted font-normal">{m.email}</div></td>
                                    <td className="px-4 py-3 text-inkDark">{m.subject}</td>
                                    <td className="px-4 py-3 text-inkMuted">{new Date(m.createdAt).toLocaleString()}</td>
                                    <td className="px-4 py-3">
                                        <span className={`text-[10px] px-2 py-1 rounded-full ${m.read ? "bg-inkDark/5 text-inkMuted" : "bg-skyblue/40 text-inkDark"}`}>
                                            {m.read ? "Read" : "New"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                            {items.length === 0 ? <tr><td colSpan={4} className="px-4 py-10 text-center text-inkMuted">No messages yet.</td></tr> : null}
                        </tbody>
                    </table>
                </div>
            </div>

            {active ? (
                <div className="fixed inset-0 z-50 bg-inkDark/40 flex items-stretch justify-end" onClick={() => setActive(null)}>
                    <div onClick={(e) => e.stopPropagation()} className="w-full max-w-xl bg-ivory h-full overflow-y-auto" data-testid="admin-contact-drawer">
                        <div className="p-6 border-b border-inkDark/5 flex items-start justify-between">
                            <div>
                                <span className="label-eyebrow">Message</span>
                                <h2 className="font-display text-2xl mt-1">{active.subject}</h2>
                                <div className="text-sm text-inkMuted">From {active.name} &lt;{active.email}&gt;</div>
                                <div className="text-xs text-inkMuted">{new Date(active.createdAt).toLocaleString()}</div>
                            </div>
                            <button onClick={() => setActive(null)} className="text-inkMuted">Close</button>
                        </div>
                        <div className="p-6 whitespace-pre-line text-inkDark/90 leading-relaxed">{active.message}</div>
                        <div className="p-6 border-t border-inkDark/5 flex gap-3">
                            <a href={`mailto:${active.email}?subject=Re:%20${encodeURIComponent(active.subject)}`} className="btn-pill text-sm" data-testid="admin-contact-reply">Reply via mail</a>
                            <button onClick={() => markRead(active, !active.read)} className="btn-ghost text-sm" data-testid="admin-contact-toggle-read">
                                {active.read ? "Mark unread" : "Mark read"}
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
}
